import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IAssemblyTag } from 'src/interfaces';
import { lang, queryKeys, requestCCApi } from 'src/utils';
import { improvedFailedToError } from 'src/utils/improvedFailedToError';

export const useCreateAssemblyTag = () => {
  return useMutation({
    mutationFn: createAssemblyTag,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.assemblyTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewAssemblyTagsWithAssembliesCount.invalidateAll(),
      );
    },
  });
};

const createAssemblyTag = async (payload: Partial<IAssemblyTag>) => {
  const request = {
    name: payload.name,
  };

  const response = await requestCCApi(
    {
      url: `/assemblyTags`,
      method: 'POST',
      data: { data: request },
    },
    true,
    improvedFailedToError(lang.create, lang.locationTag),
  );

  return response;
};
